import React from 'react';
import { motion } from 'framer-motion';
import Sidebar from '../../components/Admin/Sidebar';
import { FiUsers, FiDollarSign, FiCalendar, FiTrendingUp } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const StatsCard = ({ title, value, icon: Icon, trend, color }) => (
  <div className="bg-white p-6 rounded-sm border border-brand-light/30 shadow-sm">
    <div className="flex justify-between items-start mb-4">
      <div className={`p-3 rounded-sm ${color} text-white`}>
        <SafeIcon icon={Icon} className="text-xl" />
      </div>
      <span className="text-green-500 text-xs font-bold flex items-center gap-1">
        <SafeIcon icon={FiTrendingUp} /> {trend}
      </span>
    </div>
    <h3 className="text-brand-sage text-xs uppercase tracking-widest mb-1">{title}</h3>
    <p className="text-2xl font-serif font-bold text-brand-dark">{value}</p>
  </div>
);

const Dashboard = () => {
  const recentBookings = [
    { id: 1, guest: 'Juan Dela Cruz', checkIn: 'May 14, 2024', status: 'Confirmed', amount: '₱5,000' },
    { id: 2, guest: 'Maria Clara', checkIn: 'May 16, 2024', status: 'Pending', amount: '₱2,500' },
    { id: 3, guest: 'Jose Rizal', checkIn: 'May 20, 2024', status: 'Confirmed', amount: '₱7,500' },
  ];

  return (
    <div className="flex bg-brand-cream min-h-screen">
      <Sidebar />
      <main className="flex-grow p-8">
        <header className="mb-10 flex justify-between items-center">
          <div>
            <h1 className="font-serif text-3xl text-brand-dark font-bold">Dashboard</h1>
            <p className="text-brand-sage text-sm">Welcome back, Admin. Here's what's happening today.</p>
          </div>
          <div className="text-right">
            <p className="text-sm font-bold text-brand-olive uppercase tracking-widest">{new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
          </div>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          <StatsCard title="Total Bookings" value="128" icon={FiCalendar} trend="+12%" color="bg-blue-500" />
          <StatsCard title="Total Revenue" value="₱324,500" icon={FiDollarSign} trend="+8%" color="bg-green-600" />
          <StatsCard title="New Guests" value="42" icon={FiUsers} trend="+15%" color="bg-brand-olive" />
          <StatsCard title="Avg. Rating" value="4.9" icon={FiTrendingUp} trend="+2%" color="bg-amber-500" />
        </div>

        <div className="bg-white rounded-sm border border-brand-light/30 shadow-sm overflow-hidden">
          <div className="p-6 border-b border-brand-light/30 flex justify-between items-center">
            <h2 className="font-serif text-xl text-brand-dark font-bold">Recent Bookings</h2>
            <button className="text-brand-olive text-xs uppercase tracking-widest font-bold hover:underline">View All</button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-brand-cream/50 text-brand-sage text-xs uppercase tracking-widest">
                  <th className="px-6 py-4">Guest</th>
                  <th className="px-6 py-4">Check-in</th>
                  <th className="px-6 py-4">Status</th>
                  <th className="px-6 py-4">Amount</th>
                  <th className="px-6 py-4">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-brand-light/20">
                {recentBookings.map((booking) => (
                  <tr key={booking.id} className="hover:bg-brand-cream/20 transition-colors">
                    <td className="px-6 py-4 font-medium text-brand-dark">{booking.guest}</td>
                    <td className="px-6 py-4 text-brand-sage text-sm">{booking.checkIn}</td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-[10px] uppercase font-bold tracking-tighter ${
                        booking.status === 'Confirmed' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'
                      }`}>
                        {booking.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-brand-dark font-bold">{booking.amount}</td>
                    <td className="px-6 py-4">
                      <button className="text-brand-olive hover:text-brand-dark text-sm font-bold uppercase tracking-widest">Details</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;